/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Last_TitleInputs */

const en_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last event`)
};

const fr_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernier evenement`)
};

const de_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letztes Ereignis`)
};

const it_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo evento`)
};

const ru_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее событие`)
};

const es_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último evento`)
};

const zh_cn2_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一次活动`)
};

const ja_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のイベント`)
};

const hi_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम कार्यक्रम`)
};

const pt_pt2_image_export_preview_last_title = /** @type {(inputs: Image_Export_Preview_Last_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último evento`)
};

/**
* | output |
* | --- |
* | "Last event" |
*
* @param {Image_Export_Preview_Last_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_last_title = /** @type {((inputs?: Image_Export_Preview_Last_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Last_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_last_title(inputs)
	if (locale === "de") return de_image_export_preview_last_title(inputs)
	if (locale === "it") return it_image_export_preview_last_title(inputs)
	if (locale === "ru") return ru_image_export_preview_last_title(inputs)
	if (locale === "es") return es_image_export_preview_last_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_last_title(inputs)
	if (locale === "ja") return ja_image_export_preview_last_title(inputs)
	if (locale === "hi") return hi_image_export_preview_last_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_last_title(inputs)
	return en_image_export_preview_last_title(inputs)
});